import classnames from 'classnames';
import { toast } from 'react-toastify';

import { ReactComponent as CopySVG } from 'icons/copy.svg';

import './input.scss';

const Input = ({
  name,
  type = 'text',
  className,
  disabled,
  valid,
  validationText = 'This question is required!',
  label,
  placeholder,
  value,
  withCurrency = false,
  isCopiable = false,
  trailingLabel,
  min,
  onChange,
  onBlur,
  autoFocus = false,
  onKeyDown,
  onPaste,
}) => {
  const wrapperClasses = classnames('input-group', {
    error: !valid,
    'input-currency': withCurrency,
    [className]: className,
  });

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    toast('Copied to clipboard');
  };

  return (
    <div className={wrapperClasses}>
      <label data-cy={`${name}-label`}>{label}</label>

      <input
        disabled={disabled}
        type={type}
        name={name}
        min={min}
        className={className}
        placeholder={placeholder}
        value={value || ''}
        onChange={onChange}
        autoFocus={autoFocus}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        onBlur={onBlur}
      />
      {isCopiable && (
        <div
          style={{ top: '33px' }}
          data-rh="Copy"
          className="pointer absolute inset-y-0 right-0 flex items-center pr3"
          onClick={() => handleCopy()}
        >
          <CopySVG className="h5 w5 midgrey" aria-hidden="true" />
        </div>
      )}
      {trailingLabel && (
        <div
          style={{ top: '34px' }}
          className="absolute inset-y-0 right-0 flex items-center pr3"
        >
          {trailingLabel}
        </div>
      )}
      {!valid && <span className="error">{validationText}</span>}
    </div>
  );
};

export default Input;
